var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf05W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(1255.014 -23692.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M325.245,256a1.511,1.511,0,0,0-.165.008.5.5,0,0,0-.481.494v9.362a.494.494,0,0,0,.494.494h9.4a.494.494,0,0,0,.494-.494A9.817,9.817,0,0,0,325.245,256Z",
    transform: "translate(-1555 23451.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M323.636,266.265v-8.424a.993.993,0,0,0-1.216-.963,9.612,9.612,0,1,0,11.532,11.587.99.99,0,0,0-.963-1.22h-8.365a.988.988,0,0,1-.984-.984Z",
    transform: "translate(-1555 23451.5)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf05W);
export default __webpack_public_path__ + "static/media/icon-wf-05-w.17b856e62bae35b3e686aee9af75f38f.svg";
export { ForwardRef as ReactComponent };